import { useEffect, useState } from 'react';
import { Card } from '@fluentui/react-components';

import useFetch from '../Hooks/useFetchAPI';
import { useSignInState } from './signInState';
import ModuleConfigTable from './ModuleConfigs/ModuleConfigTable';

const adminUpdateKeyToCustomerProperty: Record<string, keyof CompanyDataResult> = {
    CompanyName: 'companyName',
    Address: 'address',
    Country: 'country',
    ContactName: 'contactName',
    Email: 'email',
    PhoneNumber: 'phoneNumber',
};

const getCompanyDetails = (props: { CustomerID: number }) => {
    const { signInState } = useSignInState();
    const { fetchAPI: fetchCompanyDetails, apiData: companyData, isLoading: isLoadingCompanyData, serverError: serverErrorCompanyData } = useFetch({ scope: 'AdminUser' })
    const { fetchAPI: updateDatabase } = useFetch({ scope: 'AdminUser' })
    const [companyInfo, setCompanyInfo] = useState<CompanyDataResult[] | null>(null);
    const [editableCompanyInfo, setEditableCompanyInfo] = useState<ModuleConfigTableProps[]>([]);

    useEffect(() => {
        const fetchCompanyDetailsAsync = async () => {
            await fetchCompanyDetails({ url: 'admin/getcompanydetails', method: 'GET' });
        };

        fetchCompanyDetailsAsync();
    }, [props.CustomerID, signInState.currentCustomerID]);

    useEffect(() => {
        if (!isLoadingCompanyData && !serverErrorCompanyData && companyData) {
            const data = companyData as unknown as CompanyData;
            const list = data.result;
            if (Array.isArray(list) && list.length > 0) {
                setCompanyInfo(list);
                const item = list[0];
                const editableCompanyInfoResult: ModuleConfigTableProps[] = [
                    { key: 'CompanyName', displayName: 'Company Display Name', value: item.companyName || '' },
                    { key: 'Address', displayName: 'Address', value: item.address || '' },
                    { key: 'Country', displayName: 'Country', value: item.country || '' },
                    { key: 'ContactName', displayName: 'Primary Contact Name', value: item.contactName || '' },
                    { key: 'Email', displayName: 'Primary Contact Email', value: item.email || '' },
                    { key: 'PhoneNumber', displayName: 'Primary Contact Phone Number', value: item.phoneNumber || '' },
                ];
                setEditableCompanyInfo(editableCompanyInfoResult);
            }
        }
    }, [isLoadingCompanyData, serverErrorCompanyData, companyData]);

    const updateCompanyDetails = async (key: string, value: string | number | boolean | Date) => {
        let formattedValue: string | number | boolean;
        if (typeof value === 'string') {
            formattedValue = encodeURIComponent(value);
        } else if (value instanceof Date) {
            formattedValue = value.toISOString();
        } else {
            formattedValue = value;
        }

        await updateDatabase({
            url: `admin/updatecustomerdetails?key=${key}&value=${formattedValue}`,
            method: 'PUT'
        });

        const prop = adminUpdateKeyToCustomerProperty[key];
        setCompanyInfo((prev) => {
            if (prev && prev.length > 0 && prop) {
                return [
                    { ...prev[0], [prop]: value },
                    ...prev.slice(1)
                ];
            }
            return prev;
        });

        setEditableCompanyInfo((prev) =>
            prev.map((row) => (row.key === key ? { ...row, value: value instanceof Date ? value.toISOString() : value } : row))
        );
    };

    return (
        <div style={{ marginLeft: '20px' }}>

            {isLoadingCompanyData && <div>Loading Company Details...</div>}
            {companyInfo && editableCompanyInfo &&
                <>
                    <p />
                    <Card className='CompanyInfo' style={{ maxWidth: '550px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '50%', textAlign: 'left' }}>Microsoft Tenant ID:</div>
                                <div style={{ width: '50%', textAlign: 'left' }}>{companyInfo[0]?.tenantID}</div>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '50%', textAlign: 'left' }}>Microsoft Tenant Name:</div>
                                <div style={{ width: '50%', textAlign: 'left' }}>{companyInfo[0]?.tenantName}</div>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '50%', textAlign: 'left' }}>Microsoft Tenant Type:</div>
                                <div style={{ width: '50%', textAlign: 'left' }}>{companyInfo[0]?.tenantType}</div>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '50%', textAlign: 'left' }}>Creation Date:</div>
                                <div style={{ width: '50%', textAlign: 'left' }}>{new Date(companyInfo[0]?.creationDate).toLocaleDateString()}</div>
                            </div>
                        </div>
                    </Card>

                    <p />
                    <div className="EditableCompanyInfo" style={{ maxWidth: '1300px' }}>
                        <ModuleConfigTable<ModuleConfigTableProps[]> data={editableCompanyInfo} appFeature={'NACompanyDetails'} onUpdate={updateCompanyDetails} />
                    </div>

                </>
            }

        </div>
    );
}

export default getCompanyDetails;
